import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { CustomsCalculator } from "@/components/landing/Calculator";
import { WhyADT } from "@/components/landing/WhyADT";
import { Process } from "@/components/landing/Process";
import { Experience } from "@/components/landing/Experience";
import { Quotes } from "@/components/landing/Quotes";
import { Gallery } from "@/components/landing/Gallery";
import { Testimonials } from "@/components/landing/Testimonials";
import { ContactCTA } from "@/components/landing/ContactCTA";
import { Footer } from "@/components/landing/Footer";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { SofiHeader } from "@/components/SofiHeader";
import SofiDemo from "@/pages/SofiDemo";
import AdminOrders from "@/pages/AdminOrders";

function Landing() {
  return (
    <div className="min-h-screen bg-black font-body text-white antialiased">
      <Header />
      <main className="pb-16 lg:pb-0">
        <Hero />
        <CustomsCalculator />
        <WhyADT />
        <Process />
        <Experience />
        <Quotes />
        <Gallery />
        <Testimonials />
        <ContactCTA />
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}

function SofiPage() {
  return (
    <div className="min-h-screen bg-[#070707]">
      <SofiHeader />
      <div className="pb-20 lg:pb-0">
        <SofiDemo />
      </div>
      <MobileBottomNav />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/sofi" element={<SofiPage />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
